import React from 'react';
import cn from 'classnames';
import { fontSize } from '../constants';
import styles from '../HorizontalBar.module.scss';

const gap = 11;

const padding = 23;

export const renderCustomizedLabel = ({
  x,
  y,
  width,
  onClick,
  fill,
  value,
}) => {
  const valueKey = value.valueKey;
  const nullContent = value.nullContent;

  const name = value.entity?.name ?? '';
  const number = value.entity[valueKey];

  const val = number === 0 && nullContent !== undefined ? nullContent : number;

  const textPosition = {
    x: x + width + gap,
    y: y - fontSize / 2,
  };

  if (!isNaN(x) && !isNaN(width)) {
    return (
      <g textAnchor="start" dominantBaseline="middle" onClick={onClick}>
        <foreignObject
          {...textPosition}
          width={`calc(100% - ${width + gap + padding}px)`}
          height="150"
        >
          <div className={styles.label}>
            <div
              style={{
                background: fill,
              }}
              className={styles.circle}
            />
            <div
              className={cn(styles.textOverflow, {
                [styles.textOverflowActive]: value.isActive,
              })}
            >
              {name ? <>{`${name} — `}</> : ''}
              <span
                className={cn({
                  [styles.textOverflowActive]: value.isActive,
                })}
              >
                {val}
              </span>
            </div>
          </div>
        </foreignObject>
      </g>
    );
  }

  return null;
};
